import { useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';


/************* ICONS IMPORTATION LNKS *************/
import { GiHamburgerMenu } from "react-icons/gi";
import { FaRegUser, FaSearch, FaShoppingCart } from "react-icons/fa";


/* scss link */
import "../Navbar/Navbar.scss";


function Navbar() {

    /************** SIDE BAR **************/
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);



    return (

        <>
            {/**************** TOP HEADER ****************/}
            <header>
                <div className="top_header_text">
                    <small className="text">FESTIVE HAMPERS WITH ALL ORDERS ABOVE ₹1890 |FREE SHIPPING</small>
                </div>
            </header>


            {/******** SIDE BAR AND LOGO AND ICONS ********/}
            <div className="nav_container">
                <div className="hamburger">
                    <GiHamburgerMenu className="fs-3" onClick={handleShow} />

                    <Offcanvas className="offcanvas bg-black text-white" show={show} onHide={handleClose}>
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>RASHKI</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <ul>
                                <li className="list-unstyled">Store</li>
                                <hr />
                                <li className="list-unstyled">COLLECTIONS</li>
                                <hr />
                                <li className="list-unstyled">PRICE DROP</li>
                                <hr />
                                <li className="list-unstyled">Gifting</li>
                                <hr />
                                <li className="list-unstyled">Corporate Inquiry</li>
                                <hr />
                                <li className="list-unstyled">Blogs</li>
                                <hr />
                                <li className="list-unstyled">About Us</li>
                                <hr />
                                <li className="list-unstyled">About Heels</li>
                                <hr />
                                <li className="list-unstyled">Contact Us</li>
                                <hr />
                                <li className="list-unstyled">Account</li>
                                <hr />
                                <li className="list-unstyled">Track Your Order</li>

                            </ul>
                        </Offcanvas.Body>
                    </Offcanvas>

                </div>

                <div className="logo">
                    <h2>RASHKI</h2>
                </div>

                <div className="Icons">
                    <div className="icon">
                        <FaRegUser className="fs-4 mx-2" />
                        <FaSearch className="fs-4 mx-2" />
                        <FaShoppingCart className="fs-4 mx-2" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Navbar;